<template>
  <v-card>
    <v-toolbar color="primary">
      <v-toolbar-title class="subheading white--text">
        ADICIONAR ÍTEM
      </v-toolbar-title>
    </v-toolbar>
    <v-card-title class="titulo">
      <span color="primary"
        >{{ page === 1 ? "Veiculos" : "Cobertura" }}
        <small class="error--text" v-if="fipeInvalida">
          Não foi possível validar o ítem novo. Verifique a presença de erros no
          preenchimento dos campos marcados.</small
        >
      </span>
      <v-spacer></v-spacer>
    </v-card-title>
    <v-card-text flex>
      <v-form ref="formulario" grid-list-lg class="content">
        <v-layout column v-if="page === 1">
          <v-layout row wrap pb-3>
            <v-flex xs12 sm5 md1>
              <v-text-field
                label="Placa"
                v-model="placa"
                :rules="regras.notNull"
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-text-field
                label="Chassi"
                v-model="chassi"
                :rules="regras.notNull"
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md1>
              <v-text-field
                label="FIPE"
                v-model="fipe"
                :mask="'######-#'"
                :error="fipeInvalida"
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-text-field
                label="Marca"
                v-model="marca"
                required
                :error="fipeInvalida"
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md3>
              <v-text-field
                label="Modelo"
                v-model="modelo"
                required
                :error="fipeInvalida"
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
          </v-layout>
          <v-layout wrap py-3>
            <v-flex xs12 sm5 md2>
              <v-select
                :items="campos.tipoVeiculoList"
                v-model="tipoVeiculo.id"
                label="Tipo de Veiculos"
                item-text="titulo"
                item-value="id"
                required
                :error="fipeInvalida"
              ></v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-select
                :items="campos.catVeiculoList"
                v-model="catVeiculo.id"
                label="Categoria do Veículo"
                placeholder="Selecione uma opção"
                item-text="titulo"
                item-value="id"
                :rules="regras.notNull"
                required
              ></v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md1>
              <v-text-field
                label="Ano Fabricação"
                v-model="anoFab"
                :rules="regras.notNull"
                required
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md1>
              <v-text-field
                label="Ano Modelo"
                v-model="anoMod"
                :error="fipeInvalida"
                required
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md1>
              <v-select
                :items="listaEstados"
                item-text="sigla"
                item-value="id"
                label="UF Pernoite"
                required
              ></v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-select
                :items="campos.usoDoVeiculoList"
                v-model="usoDoVeiculo"
                label="Uso do Veículo"
                placeholder="Selecione uma opção"
                item-text="titulo"
                item-value="id"
                :rules="regras.notNull"
                required
              ></v-select>
            </v-flex>
            <v-spacer></v-spacer>
          </v-layout>
          <v-layout wrap py-3>
            <v-flex xs12 sm5 md4>
              <v-select
                :items="campos.propriedadeRegistroDoCrlvList"
                v-model="propriedadeRegistroDoCrlv"
                label="Propriedade (Registro do CRLV)"
                placeholder="Selecione uma opção"
                item-text="titulo"
                item-value="id"
                :rules="regras.notNull"
                required
              ></v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-text-field
                class="body-1"
                label="Proprietário"
                v-model="proprietario"
                :rules="regras.notNull"
                required
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-text-field
                label="CPF/CNPJ"
                v-model="cpfCnpj"
                :mask="
                  cpfCnpj !== null && cpfCnpj.length > 11
                    ? 'NN.NNN.NNN/NNNN-##'
                    : '###.###.###-###'
                "
                :rules="regras.notNull"
                required
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md1>
              <v-radio-group
                height="50px"
                v-model="chassiRemarcado"
                row
                class="my-0 pt-0"
              >
                <span class="themeGrey--text body-1">Chassi Remarcado</span>
                <v-layout>
                  <v-flex
                    d-inline-flex
                    align-center
                    v-for="item in simOuNao"
                    :key="item.titulo"
                    ><v-radio :label="item.titulo" :value="item.value">
                    </v-radio
                  ></v-flex>
                </v-layout>
              </v-radio-group>
            </v-flex>
            <v-spacer></v-spacer>
          </v-layout>
          <v-layout wrap pt-3>
            <v-flex xs12 sm5 md1>
              <v-radio-group v-model="zeroKm" class="my-0 pt-0">
                <span class="themeGrey--text body-1">Zero Km</span>
                <v-layout>
                  <v-flex
                    d-inline-flex
                    align-center
                    v-for="item in simOuNao"
                    :key="item.titulo"
                    ><v-radio :label="item.titulo" :value="item.value">
                    </v-radio
                  ></v-flex>
                </v-layout>
              </v-radio-group>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-select
                :items="campos.diasGarantZeroKmList"
                label="Dias de Garantia Zero Km"
                placeholder="Selecione"
                v-model="diasGarantZeroKm"
                item-text="titulo"
                item-value="id"
                :rules="regras.notNull"
                required
              ></v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-menu
                v-model="menu1"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="textInicio"
                    label="Saída da Concessionária"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                    required
                  ></v-text-field>
                </template>
                <v-date-picker v-model="dateInicio" no-title scrollable>
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
          </v-layout>
        </v-layout>
        <v-layout column v-else-if="page === 2">
          <v-layout wrap py-2>
            <v-flex xs12 sm5 md1>
              <v-select
                :items="campos.tipoCoberturaList"
                v-model="tipoCobertura"
                label="Tipo de Cobertura"
                placeholder="Selecione"
                item-text="titulo"
                item-value="id"
                required
              ></v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md1>
              <v-text-field
                label="Danos Materiais"
                v-model="danosMateriais"
                required
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md1>
              <v-text-field
                label="Danos Corporais"
                v-model="danosCorporais"
                required
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex d-flex xs12 sm5 md1>
              <v-text-field
                label="Danos Morais"
                v-model="danosMoraisEEsteticos"
                required
              ></v-text-field>
              <v-tooltip left color="themeGrey" max-width="350px">
                <template v-slot:activator="{ on }">
                  <v-icon class="info--text" small v-on="on">help</v-icon>
                </template>
                <span>DANOS MORAIS E ESTÉTICOS</span>
              </v-tooltip>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex d-flex xs12 sm5 md1>
              <v-text-field
                label="Danos Terc."
                v-model="
                  danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado
                "
                required
              ></v-text-field>
              <v-tooltip left color="themeGrey" max-width="350px">
                <template v-slot:activator="{ on }">
                  <v-icon class="info--text" small v-on="on">help</v-icon>
                </template>
                <span>DANOS MATERIAIS/CORPORAIS A TERCEIROS </span>
              </v-tooltip>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md1>
              <v-text-field
                label="APP Morte"
                v-model="appMorte"
                required
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md1>
              <v-text-field
                label="APP Invalidez"
                v-model="appInvalidez"
                required
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex d-flex xs12 sm5 md1>
              <v-text-field
                label="DHMO"
                v-model="despesasMedicasHospitalaresEOdontologicas"
                required
              ></v-text-field>
              <v-tooltip left color="themeGrey" max-width="350px">
                <template v-slot:activator="{ on }">
                  <v-icon class="info--text" small v-on="on">help</v-icon>
                </template>
                <span>DESP. MÉDICAS, HOSPITALARES E ODONTOLÓGICAS</span>
              </v-tooltip>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md1>
              <v-text-field
                label="Desp. Extras"
                :value="despesasExtrasFixoFormatado"
                readonly
                disabled
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
          </v-layout>
          <v-layout wrap py-2>
            <v-flex xs12 sm5 md1>
              <v-radio-group v-model="garantiaUnica" class="my-0 pt-0">
                <span class="themeGrey--text body-1">Garantia Única</span>
                <v-layout>
                  <v-flex
                    d-flex
                    align-center
                    v-for="item in simOuNao"
                    :key="item.titulo"
                    ><v-radio :label="item.titulo" :value="item.value">
                    </v-radio
                  ></v-flex>
                </v-layout>
              </v-radio-group>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md1>
              <v-text-field
                label="Vlr. Garant. Única"
                v-model.lazy="vlrGarantiaUnica"
                v-money="maskComputed.maskMoney"
                required
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md1>
              <v-radio-group v-model="tipoDeContratacao" class="my-0 pt-0">
                <span class="themeGrey--text body-1">Tipo Contratação</span>
                <v-layout>
                  <v-flex
                    d-flex
                    align-center
                    v-for="item in campos.tipoDeContratacaoList"
                    :key="item.titulo"
                    ><v-radio :label="item.titulo" :value="item.id"> </v-radio
                  ></v-flex>
                </v-layout>
              </v-radio-group>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md1>
              <v-text-field
                type="number"
                label="% Ajuste VMR / VD"
                v-model="percAjusteVmrOuVd"
                required
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md1>
              <v-select
                :items="campos.tipoDeFranquiaList"
                v-model="tipoDeFranquia"
                label="Tipo de Franquia"
                placeholder="Selecione uma opção"
                item-text="titulo"
                item-value="id"
                required
              ></v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-select
                :items="campos.tipoDePropostaList"
                v-model="tipoDeProposta"
                label="Tipo de Proposta"
                placeholder="Selecione"
                item-text="titulo"
                item-value="id"
                required
              ></v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md1>
              <v-select
                :items="campos.classeList"
                v-model="classeBonus"
                label="Classe"
                placeholder="Selecione"
                item-text="titulo"
                item-value="id"
                required
              ></v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-select
                :items="campos.renovacaoSinistroOptions"
                v-model="renovacaoComSinistro"
                label="Tipo de Renovação"
                placeholder="Selecione"
                item-text="titulo"
                item-value="id"
                required
              ></v-select>
            </v-flex>
            <v-spacer></v-spacer>
          </v-layout>
          <v-layout wrap py-2>
            <v-flex xs12 sm5 md3>
              <v-select
                :items="campos.ciaRenovacaoList"
                v-model="ciaRenovacao"
                label="Companhia de Renovação"
                placeholder="Selecione uma opção"
                item-text="titulo"
                item-value="id"
                required
              ></v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-text-field
                class="body-1"
                label="Código da Renovação"
                v-model="codRenovacao"
                required
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm3 md1>
              <v-radio-group v-model="caminhaoBasculado" class="my-0 pt-0">
                <span class="themeGrey--text body-1">Caminhãos Basculado</span>
                <v-layout>
                  <v-flex
                    d-flex
                    align-center
                    v-for="item in simOuNao"
                    :key="item.titulo"
                    ><v-radio :label="item.titulo" :value="item.value">
                    </v-radio
                  ></v-flex>
                </v-layout>
              </v-radio-group>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm3 md1>
              <v-radio-group v-model="vlrDeNovo180Dias" class="my-0 pt-0">
                <span class="themeGrey--text body-1"
                  >Vlr. de Novo (180 dias)</span
                >
                <v-layout>
                  <v-flex
                    d-flex
                    align-center
                    v-for="item in simOuNao"
                    :key="item.titulo"
                    ><v-radio :label="item.titulo" :value="item.value">
                    </v-radio
                  ></v-flex>
                </v-layout>
              </v-radio-group>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm3 md1>
              <v-radio-group v-model="vlrDeNovo365Dias" class="my-0 pt-0">
                <span class="themeGrey--text body-1"
                  >Vlr. de Novo (365 dias)</span
                >
                <v-layout>
                  <v-flex
                    d-flex
                    align-center
                    v-for="item in simOuNao"
                    :key="item.titulo"
                    ><v-radio :label="item.titulo" :value="item.value">
                    </v-radio
                  ></v-flex>
                </v-layout>
              </v-radio-group>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm3 md2>
              <v-radio-group
                v-model="garantiaCompreensivaParaTumultos"
                class="my-0 pt-0"
              >
                <span class="themeGrey--text body-1"
                  >Compreensiva: Tumultos
                  <v-tooltip left color="themeGrey" max-width="350px">
                    <template v-slot:activator="{ on }">
                      <v-icon class="info--text" small v-on="on">help</v-icon>
                    </template>
                    <span>GARANTIA COMPREENSIVA PARA TUMULTOS</span>
                  </v-tooltip>
                </span>
                <v-layout>
                  <v-flex
                    d-flex
                    align-center
                    v-for="item in simOuNao"
                    :key="item.titulo"
                    ><v-radio :label="item.titulo" :value="item.value">
                    </v-radio
                  ></v-flex>
                </v-layout>
              </v-radio-group>
            </v-flex>
          </v-layout>
          <v-layout wrap py-2>
            <v-flex xs12 sm3 md1>
              <v-radio-group
                v-model="danosMateriaisADirigentesSociosEmpregadosEPrepostos"
                class="my-0 pt-0"
              >
                <span class="themeGrey--text body-1"
                  >Danos Mat. Dirigentes, etc
                  <v-tooltip left color="themeGrey" max-width="350px">
                    <template v-slot:activator="{ on }">
                      <v-icon class="info--text" small v-on="on">help</v-icon>
                    </template>
                    <span
                      >DANOS MATERIAIS: DIRIGENTES, SÓCIOS, EMPREG. E PREPOSTOS
                    </span>
                  </v-tooltip>
                </span>
                <v-layout>
                  <v-flex
                    d-flex
                    align-center
                    v-for="item in simOuNao"
                    :key="item.titulo"
                    ><v-radio :label="item.titulo" :value="item.value">
                    </v-radio
                  ></v-flex>
                </v-layout>
              </v-radio-group>
            </v-flex>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md1>
              <v-text-field
                label="Vlr. Danos Mat. Dirigentes"
                v-money="maskComputed.maskMoney"
                v-model="vlrDmDirigenteSociosEmpregadosPrepostos"
                required
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm3 md1>
              <v-radio-group
                v-model="danosCorporaisADirigentesSociosEmpregadosEPrepostos"
                class="my-0 pt-0"
              >
                <span class="themeGrey--text body-1"
                  >Danos Corp. Dirigentes, etc
                  <v-tooltip left color="themeGrey" max-width="350px">
                    <template v-slot:activator="{ on }">
                      <v-icon class="info--text" small v-on="on">help</v-icon>
                    </template>
                    <span
                      >DANOS CORPORAIS: DIRIGENTES, SÓCIOS, EMPREG. E PREPOSTOS
                    </span>
                  </v-tooltip></span
                >

                <v-layout>
                  <v-flex
                    d-flex
                    align-center
                    v-for="item in simOuNao"
                    :key="item.titulo"
                    ><v-radio :label="item.titulo" :value="item.value">
                    </v-radio
                  ></v-flex>
                </v-layout>
              </v-radio-group>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex >
              <v-text-field
                label="Vlr. Danos Corp. Dirigentes, etc"
                v-money="maskComputed.maskMoney"
                v-model="vlrDanosCorporaisADirigentesSociosEmpregadosEPrepostos"
                required
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-radio-group
                v-model="extensaoDeCoberturaRcfAVeiculosRebocados"
                class="my-0 pt-0"
              >
                <span class="themeGrey--text body-1"
                  >Ext. RCF Veículos Rebocados
                  <v-tooltip left color="themeGrey" max-width="350px">
                    <template v-slot:activator="{ on }">
                      <v-icon class="info--text" small v-on="on">help</v-icon>
                    </template>
                    <span>EXTENSÃO DE COBERTURA RCF A VEÍCULOS REBOCADOS </span>
                  </v-tooltip></span
                >
                <v-layout>
                  <v-flex
                    d-flex
                    align-center
                    v-for="item in simOuNao"
                    :key="item.titulo"
                    ><v-radio :label="item.titulo" :value="item.value">
                    </v-radio
                  ></v-flex>
                </v-layout>
              </v-radio-group>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md1>
              <v-text-field
                label="Vlr. Ext. RCF Veículos Rebocados"
                v-money="maskComputed.maskMoney"
                v-model="vlrExtensaoDeCoberturaRcfAVeiculosRebocados"
                required
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md1>
              <v-select
                :items="campos.kmAssistenciaList"
                v-model="kmAssistencia"
                label="Km de Assistência"
                placeholder="Selecione"
                item-text="titulo"
                item-value="id"
                required
              ></v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-select
                :items="campos.carroReservaList"
                v-model="carroReserva"
                label="Carro Reserva"
                placeholder="Selecione uma opção"
                item-text="titulo"
                item-value="id"
                required
              ></v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md1>
              <v-text-field
                label="Vlr. FIPE"
                v-money="maskComputed.maskMoney"
                v-model="vlrFipe"
                required
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md1>
              <v-text-field
                label="VD Contratado"
                v-model="vdContratado"
                v-money="maskComputed.maskMoney"
                required
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
          </v-layout>
          <v-layout wrap py-2>
            <v-flex xs12 sm5 md2>
              <v-radio-group
                v-model="coberturaAdicionalCarroceria"
                class="my-0 pt-0"
              >
                <span class="themeGrey--text body-1"
                  >Adicional Carroceria
                  <v-tooltip left color="themeGrey" max-width="350px">
                    <template v-slot:activator="{ on }">
                      <v-icon class="info--text" small v-on="on">help</v-icon>
                    </template>
                    <span>COBERTURA ADICIONAL: CARROCERIA </span>
                  </v-tooltip></span
                >
                <v-layout>
                  <v-flex
                    d-flex
                    align-center
                    v-for="item in simOuNao"
                    :key="item.titulo"
                    ><v-radio :label="item.titulo" :value="item.value">
                    </v-radio
                  ></v-flex>
                </v-layout>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 sm5 md2>
              <v-radio-group
                v-model="coberturaAdicionalEquipamentos"
                class="my-0 pt-0"
              >
                <span class="themeGrey--text body-1"
                  >Adicional Equip.
                  <v-tooltip left color="themeGrey" max-width="350px">
                    <template v-slot:activator="{ on }">
                      <v-icon class="info--text" small v-on="on">help</v-icon>
                    </template>
                    <span>COBERTURA ADICIONAL: EQUIPAMENTOS </span>
                  </v-tooltip></span
                >
                <v-layout>
                  <v-flex
                    d-flex
                    align-center
                    v-for="item in simOuNao"
                    :key="item.titulo"
                    ><v-radio :label="item.titulo" :value="item.value">
                    </v-radio
                  ></v-flex>
                </v-layout>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 sm5 md2>
              <v-radio-group
                v-model="coberturaAdicionalAcessorios"
                class="my-0 pt-0"
              >
                <span class="themeGrey--text body-1"
                  >Adicional Acessórios
                  <v-tooltip left color="themeGrey" max-width="350px">
                    <template v-slot:activator="{ on }">
                      <v-icon class="info--text" small v-on="on">help</v-icon>
                    </template>
                    <span>COBERTURA ADICIONAL: ACESSÓRIOS </span>
                  </v-tooltip></span
                >
                <v-layout>
                  <v-flex
                    d-flex
                    align-center
                    v-for="item in simOuNao"
                    :key="item.titulo"
                    ><v-radio :label="item.titulo" :value="item.value">
                    </v-radio
                  ></v-flex>
                </v-layout>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 sm5 md2>
              <v-radio-group
                v-model="coberturaAdicionalDespesasExtras"
                class="my-0 pt-0"
              >
                <span class="themeGrey--text body-1"
                  >Adicional Desp. Extras
                  <v-tooltip left color="themeGrey" max-width="350px">
                    <template v-slot:activator="{ on }">
                      <v-icon class="info--text" small v-on="on">help</v-icon>
                    </template>
                    <span>COBERTURA ADICIONAL: DESPESAS EXTRAS </span>
                  </v-tooltip>
                </span>
                <v-layout>
                  <v-flex
                    d-flex
                    align-center
                    v-for="item in simOuNao"
                    :key="item.titulo"
                    ><v-radio :label="item.titulo" :value="item.value">
                    </v-radio
                  ></v-flex>
                </v-layout>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 sm5 md2>
              <v-select
                :items="campos.descrCarroceriaList"
                v-model="descrCarroceria"
                label="Descrição da Carroceria"
                placeholder="Selecione"
                item-text="titulo"
                item-value="id"
                required
              ></v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md1>
              <v-text-field
                label="Vlr. Carroceria"
                v-money="maskComputed.maskMoney"
                v-model="vlrCarroceria"
                required
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
          </v-layout>
          <v-layout wrap py-2>
            <v-flex xs12 sm5 md3>
              <v-select
                :items="campos.descrEquipamentosList"
                v-model="descrEquipamentos"
                label="Descrição do Equipamento"
                placeholder="Selecione uma opção"
                item-text="titulo"
                item-value="id"
                required
              ></v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md1>
              <v-text-field
                label="Vlr. Equipamento"
                v-model="vlrEquipamentos"
                v-money="maskComputed.maskMoney"
                required
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-select
                :items="campos.descrAcessoriosList"
                v-model="descrAcessorios"
                label="Descrição do Acessório"
                placeholder="Selecione uma opção"
                item-text="titulo"
                item-value="id"
                required
              ></v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md1>
              <v-text-field
                label="Vlr. Acessório"
                v-money="maskComputed.maskMoney"
                v-model="vlrAcessorios"
                required
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md1>
              <v-text-field
                label="Vlr. Blindagem"
                v-money="maskComputed.maskMoney"
                v-model="vlrBlindagem"
                required
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md1>
              <v-text-field
                label="Vlr. Kit Gás"
                v-money="maskComputed.maskMoney"
                v-model="vlrKitGas"
                required
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md1>
              <v-select
                :items="opcoesVidros"
                v-model="coberturaVidros"
                label="Cobertura Vidros"
                placeholder="Selecione"
                item-text="titulo"
                item-value="id"
                required
              ></v-select>
            </v-flex>
            <v-spacer></v-spacer>
          </v-layout>
        </v-layout>
      </v-form>
    </v-card-text>

    <v-card-actions class="pa-5">
      <v-spacer></v-spacer>
      <template v-if="page === 1">
        <v-btn color="primary" flat @click="fechar">Cancelar</v-btn>
        <v-btn class="button-custom" @click="revalidaCamposFipe" flat
          >Seguinte</v-btn
        >
      </template>
      <template v-if="page === 2">
        <v-btn color="primary" flat @click="page = 1">Voltar</v-btn>
        <v-btn
          class="button-custom"
          @click="adicionarItem() ? (page = 2) : null"
          flat
          >Adicionar</v-btn
        >
      </template>
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from "axios";
import usuarioHelper from "@/helpers/usuario-logado.js";
import CustomFormat from "@/helpers/custom-format";
import { VMoney } from "v-money";
import mask from "@/helpers/mask";
import coberturaVidrosHelper from "@/helpers/cobertura-vidros.js";
import despesasExtrasHelper from "@/helpers/despesas-extras";

export default {
  name: "AdicionarItemModal",
  directives: {
    money: VMoney,
  },
  data: () => {
    return {
      dateInicio: new Date().toISOString().slice(0, 10),
      page: 1,
      menu1: false,
      simOuNao: [
        {
          value: false,
          titulo: "Não",
        },
        {
          value: true,
          titulo: "Sim",
        },
      ],
      fipeInvalida: false,
      regras: {
        notNull: [(v) => !!v || "Você não pode deixar este campo em branco"],
        cnpj: [(v) => !!String(v).match(/^[A-Za-z0-9]{12}\d{2}$/) || "CNPJ incorreto"],
      },
      placa: null,
      chassi: null,
      fipe: null,
      marca: null,
      modelo: null,
      tipoVeiculo: {},
      catVeiculo: {},
      anoMod: null,
      anoFab: null,
      ufPernoite: null,
      listaEstados: [],
      usoDoVeiculo: null,
      propriedadeRegistroDoCrlv: null,
      proprietario: null,
      cpfCnpj: null,
      chassiRemarcado: false,
      zeroKm: false,
      diasGarantZeroKm: null,
      saidaDaConcessionaria: null,
      tipoCobertura: null,
      danosMateriais: null,
      danosCorporais: null,
      danosMoraisEEsteticos: null,
      danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado:
        null,
      vlrDanosCorporaisADirigentesSociosEmpregadosEPrepostos: null,
      appMorte: null,
      appInvalidez: null,
      despesasMedicasHospitalaresEOdontologicas: null,
      despesasExtrasFixo: null,
      garantiaUnica: false,
      vlrGarantiaUnica: 0.0,
      tipoDeContratacao: 1,
      percAjusteVmrOuVd: "0",
      tipoDeFranquia: null,
      tipoDeProposta: null,
      renovacaoComSinistro: null,
      classeBonus: null,
      ciaRenovacao: null,
      codRenovacao: null,
      caminhaoBasculado: false,
      vlrDeNovo180Dias: false,
      vlrDeNovo365Dias: false,
      garantiaCompreensivaParaTumultos: false,
      danosCorporaisADirigentesSociosEmpregadosEPrepostos: false,
      danosMateriaisADirigentesSociosEmpregadosEPrepostos: false,
      extensaoDeCoberturaRcfAVeiculosRebocados: false,
      kmAssistencia: 0,
      carroReserva: null,
      vlrFipe: 0,
      vdContratado: 0,
      coberturaAdicionalCarroceria: false,
      coberturaAdicionalEquipamentos: false,
      coberturaAdicionalAcessorios: false,
      coberturaAdicionalDespesasExtras: false,
      descrCarroceria: null,
      vlrCarroceria: 0,
      descrEquipamentos: null,
      vlrDmDirigenteSociosEmpregadosPrepostos: 0,
      vlrEquipamentos: 0,
      descrAcessorios: null,
      vlrAcessorios: 0,
      vlrBlindagem: 0,
      vlrKitGas: 0,
      coberturaVidros: null,
      vlrExtensaoDeCoberturaRcfAVeiculosRebocados: 0,
    };
  },
  props: { dialog: Boolean, item: Number, campos: Object },
  computed: {
    textInicio() {
      return new Date(this.dateInicio).toLocaleDateString("pt-BR", {
        timeZone: "UTC",
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
    maskComputed: function () {
      return mask;
    },
    opcoesVidros: function () {
      return coberturaVidrosHelper.filtrarOpcoes(
        coberturaVidrosHelper.comOpcaoNenhuma(this.campos.coberturaVidrosList),
        this.catVeiculo && this.catVeiculo.id
      );
    },
    despesasExtrasFixoFormatado() {
      return this.despesasExtrasFixo === null
        ? ""
        : CustomFormat.toMoneyString(this.despesasExtrasFixo);
    },
  },
  watch: {
    "catVeiculo.id": function () {
      this.coberturaVidros = coberturaVidrosHelper.normalizarSelecao(
        this.coberturaVidros,
        this.catVeiculo && this.catVeiculo.id,
        this.campos.coberturaVidrosList
      );
    },
  },
  mounted() {
    this.carregaEstados();
  },
  created() {
    despesasExtrasHelper.buscarValorFixo().then(valor => {
      this.despesasExtrasFixo = valor;
    });
  },
  methods: {
    async revalidaCamposFipe() {

      if (!this.$refs.formulario.validate()) {
        return;
      }
      const data = await axios
        .post(
          `${process.env.URL_PLANILHAMS}/v1/revalidarCamposPlanilha/`,
          [this.camposItemNovo()],
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
            },
          }
        )
        .then((response) => response.data)
        .catch(() => null);

      if (
        !(this.fipeInvalida = !(
          data instanceof Array &&
          data.length &&
          data[0].erro === false
        ))
      )
        this.page = 2;
    },
    carregaEstados: async function () {
      const self = this;
      await axios
        .get(`${process.env.URL_GEOMS}/v1/no-auth/buscaTodosEstadosSemDiversos`)
        .then((response) => {
          self.listaEstados = response.data;
        })
        .catch((error) => {
          self.snackbarSalvarTransportadora.mensagem =
            error.response.data.message;
          self.snackbarSalvarTransportadora.sucesso = false;
          self.snackbarSalvarTransportadora.visivel = true;
          self.loadingSalvar = false;
        });
    },
    adicionarItem() {
      this.$emit("add", this.camposItemNovo());
    },
    camposItemNovo() {
      return {
        item: this.item,
        placa: this.placa,
        chassi: this.chassi,
        fipe: this.fipe,
        marca: this.marca,
        modelo: this.modelo,
        tipoVeiculo: this.tipoVeiculo,
        catVeiculo: this.catVeiculo,
        anoMod: this.anoMod,
        anoFab: this.anoFab,
        ufPernoite: this.ufPernoite,
        usoDoVeiculo: this.usoDoVeiculo,
        propriedadeRegistroDoCrlv: this.propriedadeRegistroDoCrlv,
        proprietario: this.proprietario,
        cpfCnpj: this.cpfCnpj,
        chassiRemarcado: this.chassiRemarcado,
        zeroKm: this.zeroKm,
        diasGarantZeroKm: this.diasGarantZeroKm,
        saidaDaConcessionaria: this.saidaDaConcessionaria,
        tipoCobertura: this.tipoCobertura,
        danosMateriais: this.danosMateriais,
        danosCorporais: this.danosCorporais,
        danosMoraisEEsteticos: this.danosMoraisEEsteticos,
        danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado:
          this
            .danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado,
        appMorte: this.appMorte,
        appInvalidez: this.appInvalidez,
        despesasMedicasHospitalaresEOdontologicas:
          this.despesasMedicasHospitalaresEOdontologicas,
        despesasExtras: this.despesasExtrasFixo,
        garantiaUnica: this.garantiaUnica,
        vlrGarantiaUnica: CustomFormat.removeMoneyFormat(this.vlrGarantiaUnica),
        tipoDeContratacao: this.tipoDeContratacao,
        percAjusteVmrOuVd: this.percAjusteVmrOuVd,
        tipoDeFranquia: this.tipoDeFranquia,
        tipoDeProposta: this.tipoDeProposta,
        renovacaoComSinistro: this.renovacaoComSinistro,
        classeBonus: this.classeBonus,
        ciaRenovacao: this.ciaRenovacao,
        codRenovacao: this.codRenovacao,
        caminhaoBasculado: this.caminhaoBasculado,
        vlrDeNovo180Dias: CustomFormat.removeMoneyFormat(this.vlrDeNovo180Dias),
        vlrDeNovo365Dias: CustomFormat.removeMoneyFormat(this.vlrDeNovo365Dias),
        garantiaCompreensivaParaTumultos: this.garantiaCompreensivaParaTumultos,
        danosCorporaisADirigentesSociosEmpregadosEPrepostos:
          this.danosCorporaisADirigentesSociosEmpregadosEPrepostos,
        danosMateriaisADirigentesSociosEmpregadosEPrepostos:
          this.danosMateriaisADirigentesSociosEmpregadosEPrepostos,
        extensaoDeCoberturaRcfAVeiculosRebocados:
          this.extensaoDeCoberturaRcfAVeiculosRebocados,
        kmAssistencia: this.kmAssistencia,
        carroReserva: this.carroReserva,
        vlrFipe: CustomFormat.removeMoneyFormat(this.vlrFipe),
        vdContratado: CustomFormat.removeMoneyFormat(this.vdContratado),
        coberturaAdicionalCarroceria: this.coberturaAdicionalCarroceria,
        coberturaAdicionalEquipamentos: this.coberturaAdicionalEquipamentos,
        coberturaAdicionalAcessorios: this.coberturaAdicionalAcessorios,
        coberturaAdicionalDespesasExtras: this.coberturaAdicionalDespesasExtras,
        descrCarroceria: this.descrCarroceria,
        vlrCarroceria: CustomFormat.removeMoneyFormat(this.vlrCarroceria),
        vlrDmDirigenteSociosEmpregadosPrepostos: CustomFormat.removeMoneyFormat(this.vlrDmDirigenteSociosEmpregadosPrepostos),
        descrEquipamentos: this.descrEquipamentos,
        vlrEquipamentos: CustomFormat.removeMoneyFormat(this.vlrEquipamentos),
        descrAcessorios: this.descrAcessorios,
        vlrAcessorios: CustomFormat.removeMoneyFormat(this.vlrAcessorios),
        vlrBlindagem: CustomFormat.removeMoneyFormat(this.vlrBlindagem),
        vlrKitGas: CustomFormat.removeMoneyFormat(this.vlrKitGas),
        coberturaVidros: this.coberturaVidros,
        vlrExtensaoDeCoberturaRcfAVeiculosRebocados: CustomFormat.removeMoneyFormat(this.vlrExtensaoDeCoberturaRcfAVeiculosRebocados),
      };
    },
    fechar() {
      this.$emit("fechar");
    },
  },
};
</script>

<style>
.button-custom {
  width: 100%;
  max-width: 121px;
  text-align: center;
  color: #fff !important;
  background-color: #00456e;
  border-radius: 2px;
  display: inline-block;
  padding: 9px 12px;
  cursor: pointer;

  font-weight: bold;
}

@media (min-width: 1440px) {
  .titulo {
    padding-left: 11rem;
  }
  .content {
    max-width: 1600px;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/frota/AdicionarItemModal.vue